import NumberHelper from 'helpers/number-helper';

const ArrayHelper = {
    getValues(arr, property) {
        return Object.values(arr)
            .filter((item) => property in item)
            .map((item) => item[property]);
    },
    countItems(obj) {
        return Object.keys(obj).length;
    },
};

export default ArrayHelper;

function getPropValues(objects, propName) {
    return Object.values(objects)
        .filter((object) => propName in object)
        .map((object) => object[propName]);
}

function gatherMin(list, propName) {
    let result = [],
        min;
    Object.keys(list).map((index) => {
        let item = list[index];
        if (!item.hasOwnProperty(propName)) {
            return;
        }
        if (!isEmpty(result) && min < item[propName]) {
            return;
        }
        if (isEmpty(result)) {
            min = item[propName];
        } else if (min > item[propName]) {
            result = [];
            min = item[propName];
        }
        result.push({...item});
    });

    return result;
}

function getRandomArray(incomingArr, neededLength) {
    if (incomingArr.length <= neededLength) {
        return cp(incomingArr);
    }

    const min = 0,
        max = incomingArr.length;
    let arr = [],
        isArrFilled = false;

    while (!isArrFilled) {
        const int = NumberHelper.getRandomInt(min, max);
        const val = incomingArr[int];

        if (!inArray(val, arr)) {
            arr.push(val);
        }

        if (arr.length >= neededLength) {
            isArrFilled = true;
        }
    }

    return arr;
}

function rangeOfNumbers(from, to) {
    const range = [];
    for (let i = from; i <= to; i++) {
        range.push(i);
    }

    return range;
}

function countEntries(value, arr, quantity = 0) {
    quantity = quantity || 0;
    Object.keys(arr).map((key) => {
        let item = arr[key];
        if (Array.isArray(item)) {
            quantity = countEntries(value, item, quantity);
        } else if (item === value) {
            quantity++;
        }
    });

    return quantity;
}

function getRepeatedAtLeastNTimes(arr, atLeastQuantity = 1) {
    const map = new Map();
    arr.forEach((a) => map.set(a, (map.get(a) || 0) + 1));

    return arr.filter((a) => map.get(a) >= atLeastQuantity);
}

function getUnique(arr) {
    return [...new Set(arr)];
}

function mergeMultidimensionalArr(arr) {
    return Object.keys(arr).reduce((subArr, key) => subArr.concat(arr[key]), []);
}

function groupObjectsByProp(objects, prop) {
    const groupedObjects = {};

    Object.values(objects).map((object) => {
        if (!object.hasOwnProperty(prop)) {
            return;
        }
        if (!groupedObjects.hasOwnProperty(object[prop])) {
            groupedObjects[object[prop]] = [];
        }
        groupedObjects[object[prop]].push(object);
    });

    return groupedObjects;
}

export {
    rangeOfNumbers,
    countEntries,
    getRandomArray,
    gatherMin,
    getRepeatedAtLeastNTimes,
    getUnique,
    mergeMultidimensionalArr,
    groupObjectsByProp,
    getPropValues,
};
